
import { SaleRow } from "@/models/base";
import { SaleEditRowState } from "@/utils/sale-edit/sale-edit-row-state";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			disabledOverride: false
		};
	},
	props: {
		saleEditState: {
			type: Object as ()=>SaleEditState,
			required: true
		},
		disabled: Boolean
	},
	computed: {
		row():SaleRow {
			return this.saleEditState.selectedRow;
		},
		state():SaleEditRowState{
			return this.saleEditState.productEditRowState;
		},
		isDisabled():boolean{
			if (this.disabledOverride) return false;
			return this.disabled;
		},
		icon():string{
			if (this.isDisabled) {
				return "unlock";
			}
			return "";
		},
	},
	watch: {
		row: {
			handler(){
				this.disabledOverride = this.row.Discount != 0;
			},
			immediate: true
		}
	},
	methods: {
		focus(){
			if (!this.$refs.discount) return;
			(this.$refs.discount as any).focus();
		},
		onIconClick(){
			this.disabledOverride = true;
		},
		blur(){
			if (!this.$refs.discount) return;
			(this.$refs.discount as any).blur();
		}
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
